'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Utils


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = require('react-dnd');

var _dragLayerUtil = require('./dragLayerUtil');

var _LineDragLayer = require('./LineDragLayer');

var _LineDragLayer2 = _interopRequireDefault(_LineDragLayer);

require('./CanvasDragLayer.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var workspaceDragLayerConnect = function workspaceDragLayerConnect(monitor) {
    return {
        isDragging: monitor.isDragging(),
        itemType: monitor.getItemType(),
        item: monitor.getItem()
    };
};

var CanvasDragLayer = (_dec = (0, _reactDnd.DragLayer)(workspaceDragLayerConnect), _dec(_class = function (_React$Component) {
    _inherits(CanvasDragLayer, _React$Component);

    function CanvasDragLayer() {
        _classCallCheck(this, CanvasDragLayer);

        return _possibleConstructorReturn(this, (CanvasDragLayer.__proto__ || Object.getPrototypeOf(CanvasDragLayer)).apply(this, arguments));
    }

    _createClass(CanvasDragLayer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                isDragging = _props.isDragging,
                itemType = _props.itemType,
                item = _props.item;


            if (!(isDragging && (0, _dragLayerUtil.isLineAffectedByDrag)(item, itemType))) return null;

            return _react2.default.createElement(
                'div',
                { className: 'CanvasDragLayer' },
                _react2.default.createElement(_LineDragLayer2.default, null)
            );
        }
    }]);

    return CanvasDragLayer;
}(_react2.default.Component)) || _class);


CanvasDragLayer.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    isDragging: _propTypes2.default.bool,
    itemType: _propTypes2.default.string,
    item: _propTypes2.default.object
};

exports.default = CanvasDragLayer;


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/dnd/CanvasDragLayer.js
// module id = 1690
// module chunks = 0